import fetch from 'isomorphic-fetch';
import { checkStatus } from '../../util';
import { ROOT } from '../../../constants/root';

export function getGroups() {
	return function(dispatch, getState) {		

		const URL = `${ROOT}/group/report/`;	

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			dispatch(setGroupsList(json));
		})
		.catch((e) => {
			console.error(e);			
		});
	};
}

function setGroupsList(groups) {
	return {
		type: "SET_GROUPS_LIST",
		groups
	};	
}


// WEBPACK FOOTER //
// ./src/state/domains/groups/actions.js